module.exports = "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/hero-desktop-8310d22bfd6ef0dcace3358bc4135757.webp";